export function calculatePupilPosition(centerX, centerY, mouseX, mouseY, maxDistance = 8) {
  const distanceX = centerX - mouseX;
  const distanceY = centerY - mouseY;
  const distance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);

  const angle = Math.atan2(distanceY, distanceX);
  const limited = Math.min(distance, maxDistance);

  const limitedX = Math.cos(angle) * limited;
  const limitedY = Math.sin(angle) * limited;

  return { x: limitedX, y: limitedY };
}

export function rectCenter(rect) {
  return {
    cx: rect.left + rect.width / 2,
    cy: rect.top + rect.height / 2,
  };
}

export function computeEyePositions(leftRect, rightRect, mouseX, mouseY, maxDistance = 8) {
  const { cx: lcx, cy: lcy } = rectCenter(leftRect);
  const { cx: rcx, cy: rcy } = rectCenter(rightRect);

  return {
    leftEye: calculatePupilPosition(lcx, lcy, mouseX, mouseY, maxDistance),
    rightEye: calculatePupilPosition(rcx, rcy, mouseX, mouseY, maxDistance),
  };
}

export function getRectById(id) {
  const el = document.getElementById(id);
  return el ? el.getBoundingClientRect() : null;
}
